// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"55f6106c","489":"c3b23034","526":"705da7a3","842":"89e981b0"}[chunkId] + ".chunk.css";
};